import { CountId, DropDownModel, DropDownWithLabelModel } from "./dropDown";
import { RisksNetworkResponseModel } from "./risksNetwork";
import { SimpleAdditionalInsuranceModel } from "./additionalInsurances";
import { CalculateStore } from "../stores/calculateStore";

export enum NnwInsuranceSum {
    nnwInsuranceSum5000 = "SUM_5000",
    nnwInsuranceSum10000 = "SUM_10000",
    nnwInsuranceSum20000 = "SUM_20000",
    nnwInsuranceSum40000 = "SUM_40000",
    nnwInsuranceSum60000 = "SUM_60000"
}

export interface NnwTypeModel extends SimpleAdditionalInsuranceModel {
    numberOfClients: CountId;
    insuranceSum: NnwInsuranceSum;
}

export const DefaultNnwType: NnwTypeModel = {
    checked: false,
    numberOfClients: CountId.one,
    insuranceSum: NnwInsuranceSum.nnwInsuranceSum5000,
    rate: null,
    getRisksNetworkValue: (response: RisksNetworkResponseModel) => response.nnw,
    getValuesFromRetrievedCalculation: (insurance: any, calculateStore: CalculateStore) => {
        calculateStore.additionalInsurances.nnwType.numberOfClients = insurance.nnw?.numberOfClients ?? CountId.one;
        calculateStore.additionalInsurances.nnwType.insuranceSum = insurance.nnw?.insuranceSum ?? NnwInsuranceSum.nnwInsuranceSum5000;
        calculateStore.additionalInsurances.nnwType.checked = !!insurance.nnw;
    }
};

export interface NnwSeniorModel extends SimpleAdditionalInsuranceModel {
    nnwNumberOfSeniors: CountId;
}

export interface NnwHeartAttackAndStrokeModel extends SimpleAdditionalInsuranceModel {
    numberOfClients: CountId;
}

export const fiveNumberOfClients = [
    {
        id: CountId.one,
        displayName: "1"
    },
    {
        id: CountId.two,
        displayName: "2"
    },
    {
        id: CountId.three,
        displayName: "3"
    },
    {
        id: CountId.four,
        displayName: "4"
    },
    {
        id: CountId.five,
        displayName: "5"
    }
];

export const eightNumberOfClients = [
    ...fiveNumberOfClients,
    {
        id: CountId.six,
        displayName: "6"
    },
    {
        id: CountId.seven,
        displayName: "7"
    },
    {
        id: CountId.eight,
        displayName: "8"
    }
];

export function getNnwNumberOfClientsDropDown(type: "insureds" | "seniors" | "heartAttackAndStrokeInsureds", isPolicyRenewal: boolean): DropDownWithLabelModel {
    let label = "";

    switch (type) {
        case "insureds":
            label = "Liczba ubezpieczonych";
            break;
        case "seniors":
            label = "Liczba ubezpieczonych seniorów";
            break;
        case "heartAttackAndStrokeInsureds":
            label = "Liczba ubezpieczonych od zawału i udaru";
            break;
    }

    return {
        label,
        dropDown: isPolicyRenewal ? eightNumberOfClients : fiveNumberOfClients
    };
}

export const NnwInsuranceSumDropDown: DropDownModel[] = [
    {
        id: NnwInsuranceSum.nnwInsuranceSum5000,
        displayName: "5 000 zł"
    }, {
        id: NnwInsuranceSum.nnwInsuranceSum10000,
        displayName: "10 000 zł"
    }, {
        id: NnwInsuranceSum.nnwInsuranceSum20000,
        displayName: "20 000 zł"
    }, {
        id: NnwInsuranceSum.nnwInsuranceSum40000,
        displayName: "40 000 zł"
    }, {
        id: NnwInsuranceSum.nnwInsuranceSum60000,
        displayName: "60 000 zł"
    }
];
